import { DishFirstFoodItemPreviewFragment } from 'src/gqlReactTypings.generated.d';

export const isFoodItem = (item): item is DishFirstFoodItemPreviewFragment => item.__typename === 'FoodItem';
